import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IwMenu from "../../../app/IwMenu";
import { useNavigate } from "react-router-dom";

export const ActionCell = ({ row }) => {
  
  const navigate = useNavigate();
  
  return (
    <IwMenu
            label={<MoreVertIcon fontSize="large" />}
            tooltipProps={{
              title: "Options",
            }}
            triggerComponentSx={{
              margin: "0 8px",
              padding: "2px 0",
            }}
            items={[
              {
                id: "user",
                label: "Go To User",
                onClick: () => {
                  navigate(`/admin/${row.original.userID}`, {
                    state: { userData: row.original },
                  })
                },
              },
              {
                id: "userSummary",
                label: "View User Summary",
                onClick: () => {},
              },
            ]}
    />
  );
};